import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from "jquery";
import { findTaxonomyObjectByName } from '../helpers';

import TaxonomyFilter from './filters/TaxonomyFilter';
import DateFilter from './filters/DateFilter';
import PostTypeFilter from './filters/PostTypeFilter';

class Sidebar extends Component {

  handleExpandClick() {
    if (!$('.Sidebar__filter-container').hasClass('Sidebar__filter-container--open')) {
      $('.Sidebar__expand-button').addClass('Sidebar__expand-button--open').find('span').html('–');
      $('.Sidebar__filter-container').addClass('Sidebar__filter-container--open').slideDown();
    }
    else {
      $('.Sidebar__expand-button').removeClass('Sidebar__expand-button--open');
      $('.Sidebar__filter-container').removeClass('Sidebar__filter-container--open').slideUp();
    }
  };

  render() {
    if (this.props.query === null) {
      return null;
    }
    else {
      return (
        <aside className="Sidebar">
          <div className="Sidebar__container">
            <h3 className="Sidebar__headline"><strong>filter</strong> results</h3>
            <button className="Sidebar__expand-button" onClick={function() { this.handleExpandClick(); }.bind(this)}><strong>filter</strong> results <span>+</span></button>
            <div className="Sidebar__filter-container">
              {(this.props.query.className === "post-type-archive-project") && (
                <div className="Sidebar__filters">
                  {(this.props.filterOptions.topics.length > 0) && (
                    <TaxonomyFilter label="Topics" taxonomyName="topics" taxonomy={this.props.filterOptions.topics} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  {(this.props.filterOptions.capability.length > 0) && (
                    <TaxonomyFilter label="Capabilities" taxonomyName="capability" taxonomy={this.props.filterOptions.capability} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  {(this.props.filterOptions.status.length > 0) && (
                    <TaxonomyFilter label="Project Status" taxonomyName="status" taxonomy={this.props.filterOptions.status} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                </div>
              )}
              {(this.props.query.className === "post-type-archive-resource") && (
                <div className="Sidebar__filters">
                  {(this.props.filterOptions.topics.length > 0) && (
                    <TaxonomyFilter label="Topics" taxonomyName="topics" taxonomy={this.props.filterOptions.topics} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  {(this.props.filterOptions.capability.length > 0) && (
                    <TaxonomyFilter label="Capabilities" taxonomyName="capability" taxonomy={this.props.filterOptions.capability} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  {(this.props.filterOptions.resourceType.length > 0) && (
                    <TaxonomyFilter label="Resource Type" taxonomyName="resourceType" taxonomy={this.props.filterOptions.resourceType} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  
                  <DateFilter date={this.props.filterOptions.date} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                </div>
              )}
              {(this.props.query.className === "post-type-archive-news-events") && (
                <div className="Sidebar__filters">
                  {(this.props.filterOptions.categories.length > 0) && (
                    <TaxonomyFilter label="News Type" taxonomyName="categories" taxonomy={this.props.filterOptions.categories} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}

                { /* <TaxonomyFilter taxonomy={findTaxonomyObjectByName('categories', this.props.wpData.taxonomies)} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} /> */ }
                  <DateFilter date={this.props.filterOptions.date} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                </div>
              )}
              {(this.props.query.className === "search" || this.props.query.className === "archive") && (
                <div className="Sidebar__filters">
                  {(this.props.filterOptions.topics.length > 0) && (
                    <TaxonomyFilter label="Topics" taxonomyName="topics" taxonomy={this.props.filterOptions.topics} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  {(this.props.filterOptions.capability.length > 0) && (
                    <TaxonomyFilter label="Capabilities" taxonomyName="capability" taxonomy={this.props.filterOptions.capability} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  {(this.props.filterOptions.postType.length > 0) && (
                    <PostTypeFilter label="Type" postType={this.props.filterOptions.postType} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}
                  {(this.props.filterOptions.date.length > 0) && (
                    <DateFilter date={this.props.filterOptions.date} applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} query={this.props.query} />
                  )}  
                </div>
              )}
            </div>
          </div>
        </aside>
      );
    }
  };
};

Sidebar.propTypes = {
  applyFilter: PropTypes.func,
  filterOptions: PropTypes.object,
  query: PropTypes.object,
};


export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js